module.exports = __webpack_public_path__ + "static/media/vermi_yield.64c02522.png";